import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/commerce-php/commerce-php/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "magento_adobestockimageapi-module"
    }}>{`Magento_AdobeStockImageApi module`}</h1>
    <p>{`The Magento_AdobeStockImageApi module module serves as application program interface (API) for the Adobe Stock image.`}</p>
    <h2 {...{
      "id": "extensibility"
    }}>{`Extensibility`}</h2>
    <p>{`Extension developers can interact with the Magento_AdobeStockImageApi module. For more information about the Magento extension mechanism, see `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/php/development/components/plugins/"
      }}>{`Magento plug-ins`}</a>{`.`}</p>
    <p><a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/php/development/components/dependency-injection/"
      }}>{`The Magento dependency injection mechanism`}</a>{` enables you to override the functionality of the Magento_AdobeStockImageApi module.`}</p>
    <h2 {...{
      "id": "additional-information"
    }}>{`Additional information`}</h2>
    <p>{`For information about significant changes in patch releases, see `}<a parentName="p" {...{
        "href": "https://experienceleague.adobe.com/docs/commerce-operations/release/notes/overview.html"
      }}>{`2.3.x Release information`}</a>{`.`}</p>
    <InlineAlert slots="text" mdxType="InlineAlert" />
The version of this module is 1.3.3.

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      